export enum EmployerIndustry {
  Agriculture = 'Agriculture, fishing and game management',
  Accommodation = 'Accommodation activities',
  CleaningServices = 'Cleaning and laundry activities',
  Construction = 'Construction',
  Education = 'Education',
  EnergyAndWater = 'Energy and water supply',
  FinanceAndInsurance = 'Finance - and insurance activities',
  FoodAndBeverage = 'Food and beverage activities',
  Forestry = 'Forestry',
  HealthServices = 'Health services',
  IT = 'Information technology',
  Industrial = 'Industry',
  MiningAndForestry = 'Mining and forestry activities',
  NationalDefense = 'National defense',
  Organizational = 'Organizational activities',
  ProtectionAndSecurity = 'Protection, police, fire department',
  PublicAdmin = 'Public administration',
  RealEstateAndRental = 'Real estate and rental services',
  RecreationAndCulture = 'Recreation and cultural services',
  Religious = 'Religious activities',
  Research = 'Research',
  Services = 'Service, other',
  SocialServices = 'Social services',
  TechnicalServices = 'Technical services and services for the common life',
  Trade = 'Trade',
  Transportation = 'Transportation',
  Unknown = "Unknown / I can't say",
}
